import { Button } from '@/components/ui/button';
import { AlertDialog, AlertDialogContent, AlertDialogHeader, AlertDialogTitle, AlertDialogDescription, AlertDialogFooter, AlertDialogCancel } from '@/components/ui/alert-dialog';

const messages = {
  controllato: ['Segnare come controllata?', 'La voce verrà rimossa dalla dashboard e dai prossimi PDF. Non verrà ripristinata dai successivi aggiornamenti.', 'Conferma controllo'],
  completa: ['Completare questa attività?', 'La voce verrà spostata tra le funzionalità completate, con la data di oggi.', 'Conferma completamento'],
  delete: ['Eliminare questa voce?', 'La voce non comparirà più nella dashboard e nei prossimi PDF. Non verrà ripristinata dai successivi aggiornamenti.', 'Elimina voce'],
};

export const ReportConfirmation = ({ pending, busy, error, onClose, onConfirm }) => {
  const message = messages[pending?.action] || messages.delete;
  return (
    <AlertDialog open={Boolean(pending)} onOpenChange={(open) => { if (!open && !busy) onClose(); }}>
      <AlertDialogContent data-testid="report-confirm-dialog" className="max-h-[85vh] w-[calc(100%-2rem)] overflow-y-auto rounded-lg">
        <AlertDialogHeader>
          <AlertDialogTitle data-testid="report-confirm-title">{message[0]}</AlertDialogTitle>
          <AlertDialogDescription data-testid="report-confirm-description">{message[1]}</AlertDialogDescription>
        </AlertDialogHeader>
        <p data-testid="report-confirm-item" className="break-words text-sm font-medium [overflow-wrap:anywhere]">{pending?.entry.titolo || pending?.entry.testo}</p>
        {error && <p role="alert" data-testid="report-confirm-error" className="text-sm text-red-700">{error}</p>}
        <AlertDialogFooter>
          <AlertDialogCancel data-testid="report-confirm-cancel" disabled={busy}>Annulla</AlertDialogCancel>
          <Button data-testid="report-confirm-submit" onClick={onConfirm} disabled={busy} className={pending?.action === 'delete' ? 'bg-red-600 hover:bg-red-700' : 'bg-blue-600 hover:bg-blue-700'}>{busy ? 'Salvataggio…' : message[2]}</Button>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
};